// extracted by mini-css-extract-plugin
module.exports = {"ParentCategoriesContainer":"_2J94J","CollectionHeading":"_2-BNJ"};